import React from 'react'
import {
  MenuItem
} from 'components/Sidebar'
import KanBoIcon from 'components/KanBoIcon'
import { useSelector } from 'react-redux'
import LayoutGroupBoard from './DeskSidebarItem/LayoutGroupBoard'

type Props = {
  boardId: number
}

const RecentBoard: React.FC<Props> = ({
  boardId,
}) => {
  const isReady = useSelector<any, boolean>(state => Boolean(state.kanbo.boardsById[boardId]))

  if (!isReady) {
    return (
      <MenuItem
        icon={<KanBoIcon />}
        title={<KanBoIcon spin name='kanbo-16-loading' />}
      />
    )
  }

  return (
    <LayoutGroupBoard
      boardId={boardId}
    />
  )
}

export default RecentBoard

